import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProductCollection from './pages/product-collection';
import PrivacyPolicy from './pages/privacy-policy';
import ContactPage from './pages/contact';
import ThankYouPage from './pages/thank-you-page';
import TermsConditions from './pages/terms-conditions';
import AboutPage from './pages/about-page';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/product-collection" element={<ProductCollection />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/thank-you-page" element={<ThankYouPage />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/about-page" element={<AboutPage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
